import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TreeNode } from 'src/app/models/MenuData';
import { MenuService } from 'src/app/services/menu.service';

@Component({
  selector: 'app-roles-view',
  templateUrl: './roles-view.component.html',
  styleUrls: ['./roles-view.component.css']
})
export class RolesViewComponent {
  selectedIds:number[]=[];
  nodes: TreeNode[] =[];
  activeTab:number=1;
  roleForm: FormGroup;
  submittedRoleForm:boolean=false;
  submittedPermissionForm:boolean=false;
  permissions: TreeNode[] = [];
  id:number = 0;
  editUrl:any;
  canEdit : boolean = false;
  menuId:number = 0;
  menuUrl : string = "";
  constructor(private fb: FormBuilder,private menuService: MenuService,private router:Router ) {
      let obj = this.router.getCurrentNavigation()?.extras?.state;
      if(obj)
      {
        this.menuId = parseInt(obj['menuId'])??0;
        this.menuUrl = obj['menuUrl'];
        this.canEdit = obj['canEdit'];
        this.editUrl = obj['editUrl'];
        this.id = parseInt(obj['id']);
        this.getFormData(this.id);
      }
      this.roleForm = this.fb.group({
        "roleId": ['', [Validators.required]],
        "roleName": ['', [Validators.required]],
        "roleDescription": ['', [Validators.required]],
        "userMenus":[]
      });
    }

  get roleFormControl() {
    return this.roleForm.controls;
  }

  changeTab(tab:number)
  {
    this.activeTab = tab;
  }

  async saveNext(tab:number,isPrevious:boolean = false)
  {    
    if(tab == 2 && isPrevious == false)
    {
      this.submittedRoleForm = true;
        if(this.roleForm.valid)
        {
          this.activeTab = tab;
        }      
    }
    else
    {
      this.activeTab = tab;
    }
  }

  async getFormData(id:number)
  {
    const res = await this.menuService.GetRolesPermissionById(id)??undefined;
      if (res != null && res.result) {
        debugger;
        this.roleForm.patchValue(res.result);    
        let userMenus =  res.result.userMenus;   
        this.permissions = JSON.parse(JSON.stringify(userMenus));
        //this.rolePermission = res.result.userMenus.map((m:TreeNode)=> {return {roleId:res.result.roleId,permissionId:m.menuId,status:m.isSelected}})
        for(var i=0; i<this.permissions.length; i++) { // add childs to every item
          this.permissions[i].children = [];
        }
        let tempSe = JSON.parse(JSON.stringify(this.permissions));
        let dddd= tempSe.filter((f:any)=>{f.isSelected == true});
        this.selectedIds =tempSe.filter((f:any)=>{return f.isSelected == true}).map((m:any)=>{return m.menuId});
        this.buildTree(this.permissions,undefined);
        this.nodes = this.permissions;
      } 
  }

  buildTree(tree:TreeNode[], item:any) {
    if (item) { // if item then have parent
        for (var i=0; i<tree.length; i++) { // parses the entire tree in order to find the parent
            tree[i].collapsed = !tree[i].isSelected;
            if (String(tree[i].menuId) === String(item.menuAuthorityId)) { // bingo!
                item.collapsed = !item.isSelected;
                tree[i].children.push(item); // add the child to his parent
                break;
            }
            else this.buildTree(tree[i].children, item); // if item doesn't match but tree have childs then parses childs again to find item parent
        }
    }
    else { // if no item then is a root item, multiple root items are supported
        var idx = 0;
        while (idx < tree.length)
            if (tree[idx].menuAuthorityId != 0) 
            this.buildTree(tree, tree.splice(idx, 1)[0]) // if have parent then remove it from the array to relocate it to the right place
            else idx++; // if doesn't have parent then is root and move it to the next object
        }
    }

    backBtClick(){
      this.router.navigateByUrl(this.editUrl,{ state: { id:this.id, menuId : this.menuId, menuUrl : this.menuUrl, canEdit : this.canEdit, editUrl : this.editUrl }});
    }
    
    homeBtClick(){
      this.router.navigateByUrl(this.menuUrl,{ state: { menuId:this.menuId, menuUrl : this.menuUrl }});
    }	
}
